<template>
  <div class="swiper-container">

    <div class="header-top">
      <div class="header-right d-flex align-center mb-4 mb-sm-0">
        <img @click="$router.push('/sub/light-blocks')" style="width: 77px;" src="@/assets/bloc_logo.svg" alt="">
      </div>
      <div class="header-left d-flex justify-space-between ">
        <div v-if="searched" class="white d-flex">
          <input type="search" placeholder="Search">
          <v-icon
              @click="searched=false"
          >mdi-magnify
          </v-icon>
        </div>
        <div v-else class="box-icon">
          <button class="box-icon-search" @click="searched=true">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
              <path
                  d="M24.6582 21.6162L19.79 16.748C19.5703 16.5283 19.2725 16.4062 18.96 16.4062H18.1641C19.5117 14.6826 20.3125 12.5146 20.3125 10.1562C20.3125 4.5459 15.7666 0 10.1562 0C4.5459 0 0 4.5459 0 10.1562C0 15.7666 4.5459 20.3125 10.1562 20.3125C12.5146 20.3125 14.6826 19.5117 16.4062 18.1641V18.96C16.4062 19.2725 16.5283 19.5703 16.748 19.79L21.6162 24.6582C22.0752 25.1172 22.8174 25.1172 23.2715 24.6582L24.6533 23.2764C25.1123 22.8174 25.1123 22.0752 24.6582 21.6162ZM10.1562 16.4062C6.7041 16.4062 3.90625 13.6133 3.90625 10.1562C3.90625 6.7041 6.69922 3.90625 10.1562 3.90625C13.6084 3.90625 16.4062 6.69922 16.4062 10.1562C16.4062 13.6084 13.6133 16.4062 10.1562 16.4062Z"
                  fill="white"/>
            </svg>
          </button>
          <a class="box-icon-user" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="none">
              <g clip-path="url(#clip0_74_55)">
                <path
                    d="M12.6163 14.1768C16.4982 14.1768 19.6476 11.0273 19.6476 7.14551C19.6476 3.26367 16.4982 0.114258 12.6163 0.114258C8.7345 0.114258 5.58508 3.26367 5.58508 7.14551C5.58508 11.0273 8.7345 14.1768 12.6163 14.1768ZM18.8663 15.7393H16.1759C15.0919 16.2373 13.8859 16.5205 12.6163 16.5205C11.3468 16.5205 10.1456 16.2373 9.05676 15.7393H6.36633C2.91418 15.7393 0.116333 18.5371 0.116333 21.9893V22.7705C0.116333 24.0645 1.16614 25.1143 2.46008 25.1143H22.7726C24.0665 25.1143 25.1163 24.0645 25.1163 22.7705V21.9893C25.1163 18.5371 22.3185 15.7393 18.8663 15.7393Z"
                    fill="#fff"/>
              </g>
              <defs>
                <clipPath id="clip0_74_55">
                  <rect width="25" height="25" fill="white" transform="translate(0.116333 0.114258)"/>
                </clipPath>
              </defs>
            </svg>
          </a>
          <v-menu class="header-color" offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text
                     class="mt-0"
                     v-bind="attrs"
                     v-on="on"
              >
                <h6 class="hover font-weight-bold">{{ flag[selectedFlag] }}</h6>
                <!--                      <img width="30" :src="flag[selectedFlag]" :alt="flag[selectedFlag]">-->
              </v-btn>
            </template>
            <div class="header-color d-flex flex-column"
            >
              <div
                  v-if="i!==selectedFlag"

                  @click="changeLanguage(i)" class="menu-item d-flex justify-center align-center py-2 black--text"
                  v-for="(item,i) in flag" :key="i"
              >
                {{ item }}
                <!--                      <img width="30" :src="item" :alt="i">-->
              </div>
            </div>
          </v-menu>
        </div>

        <div @click="drawerVisible = true"
             class="hamburglar">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;"
               xml:space="preserve">
                        <g>
                            <path style="fill:#74B73B;"
                                  d="M479.18,91.897H32.821C14.69,91.897,0,77.207,0,59.077s14.69-32.821,32.821-32.821H479.18   c18.13,0,32.82,14.69,32.82,32.821S497.31,91.897,479.18,91.897z"></path>
                          <path style="fill:#74B73B;"
                                d="M295.385,288.821H32.821C14.69,288.821,0,274.13,0,256s14.69-32.821,32.821-32.821h262.564   c18.13,0,32.821,14.69,32.821,32.821S313.515,288.821,295.385,288.821z"></path>
                        </g>
            <path style="fill:#9ad26a;"
                  d="M479.18,288.821h-52.513c-18.13,0-32.821-14.69-32.821-32.821s14.69-32.821,32.821-32.821h52.513  c18.13,0,32.82,14.69,32.82,32.821S497.31,288.821,479.18,288.821z"></path>
            <path style="fill:#74B73B;"
                  d="M479.18,485.744H32.821C14.69,485.744,0,471.053,0,452.923c0-18.13,14.69-32.821,32.821-32.821  H479.18c18.13,0,32.82,14.69,32.82,32.821C512,471.053,497.31,485.744,479.18,485.744z"></path>
                        </svg>
        </div>
      </div>

      <div
          :class="[drawerVisible?'right-drawer-active':'', 'right-drawer']"
      >
        <div style="text-align: left; margin: 20px 11px 0">
          <button class="close" @click="drawerVisible = false;isClosed">
            <svg viewPort="0 0 12 12" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
              <line x1="1" y1="11"
                    x2="11" y2="1"
                    stroke="#161616"
                    stroke-width="2"/>
              <line x1="1" y1="1"
                    x2="11" y2="11"
                    stroke="#161616"
                    stroke-width="2"/>
            </svg>
          </button>
        </div>
        <nav>
          <ul class="nav-header">

            <div v-for="(item,i) in headerItems.links" :key="i">

              <button v-if="item.type==='sublayer'" @click="isDropped=i"
                      class="drop d-flex justify-space-between align-center w-100">
                <span>{{ item.name }}</span>
                <svg v-if="item.type!=='single'" width="16" height="11" viewBox="0 0 16 11" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.125 5.32507L1.875 5.32507M1.875 5.32507L6.25 9.55945M1.875 5.32507L6.25 1.09068"
                        stroke="#161616" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>
              <button v-else @click="$router.push(item.route)"
                      class="drop d-flex justify-space-between align-center w-100">
                <span>{{ item.name }}</span>
                <svg v-if="item.type!=='single'" width="16" height="11" viewBox="0 0 16 11" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.125 5.32507L1.875 5.32507M1.875 5.32507L6.25 9.55945M1.875 5.32507L6.25 1.09068"
                        stroke="#161616" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>

              <div v-show="item.subDomain.length>0" v-for="(sub,index) in item.subDomain" :key="index"
                   class="dropped-box" v-if="isDropped===i">
                <router-link :to="sub.route" class="dropped-box-item">{{ sub.name }}</router-link>

              </div>
            </div>


          </ul>
        </nav>
      </div>
      <!-- We will make the mask fill the screen while the menu is visible. Because its z-index is 1 less than that of the menu, the menu will still be displayed on top of it -->
      <div
          :class="[drawerVisible?'drawer-mask-active':'', 'drawer-mask']"
          @click="drawerVisible = false"
      ></div>
    </div>
    <swiper class="swiper-content" :options="swiperOption">
      <swiper-slide v-for="(item,index) in sliderItems" :key="index">
        <div class="swiper-box">
          <img :src="item.photo_file" alt="#" class="swiper-img">
          <div class="swiper-box-text">
            <H2 class="swiper-title">{{ item.title }}</H2>
            <!--                        <p class="swiper-des">{{item.des}}</p>-->
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper.scss';
import SwiperCore, {Autoplay} from "swiper";
import {getCurrentLang, storeCurrentLang} from "../../data/AuthTokenStorage";

SwiperCore.use([Autoplay]);
export default {
  name: 'newSubSlider',
  title: 'Navigation',
  props: {
    sliderItems: Array,
    headerItems: Array,
  },
  components: {
    Swiper,
    SwiperSlide,
    Autoplay
  },
  data() {
    return {
      searched:false,
      selectedFlag: 0,
      flag: [
        'IR',
        'EN',
        'AR'
        // require('../../assets/images/flags/ir.svg'),
        // require('../../assets/images/flags/en.svg'),
        // require('../../assets/images/flags/ar.svg'),
      ],
      changeLanguage(i) {
        this.selectedFlag = i;
        if (this.selectedFlag === 0) {
          this.$i18n.locale = 'fa';
        }
        if (this.selectedFlag === 1) {
          this.$i18n.locale = 'en'
        }
        if (this.selectedFlag === 2) {
          this.$i18n.locale = 'ar'
        }
        storeCurrentLang(this.$i18n.locale);
      },
      isDropped: null,

      isClosed: true,
      drawerVisible: false,
      sliderSlides: {
        item1: {
          src: require('../../assets/images/home-slider/1.jpg'),
          title: 'لورم ایپسوم متن ساختگی با صنعت چاپ',
          des: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم ازتولید سادگی نامفهوم ازتولید سادگی نامفهوم از صنعت چاپ',
        },
        item2: {
          src: require('../../assets/images/home-slider/2.jpg'),
          title: 'لورم ایپسوم متن ساختگی با از صنعت چاپ',
          des: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ',
        },
        item3: {
          src: require('../../assets/images/home-slider/9.jpg'),
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ',
          des: 'لورم ایپسوم متن ساختگی  با تولید سادگی با تولید سادگی نامفهوم از صنعت چاپ',
        },
        item4: {
          src: require('../../assets/images/home-slider/12.jpg'),
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ',
          des: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ',
        },
      },
      swiperOption: {
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 3000,
        autoplay: {
          delay: 3000,
        },
      }
    }
  },
  methods:{
    changeLanguage(i) {
      this.selectedFlag = i;
      if (this.selectedFlag === 0) {
        this.$i18n.locale = 'fa';
      }
      if (this.selectedFlag === 1) {
        this.$i18n.locale = 'en'
      }
      if (this.selectedFlag === 2) {
        this.$i18n.locale = 'ar'
      }
      storeCurrentLang(this.$i18n.locale);
    },
    getSelectedLang(){
      if (getCurrentLang()==="fa"){
        this.selectedFlag=0;
      }
      else if (getCurrentLang()==="en"){
        this.selectedFlag=1;
      }
      else if (getCurrentLang()==="ar"){
        this.selectedFlag=2;
      }
      else {
        storeCurrentLang('fa');
        this.selectedFlag=0;
      }

    },
  },
  created() {
    this.getSelectedLang();
  }

}
</script>

<style lang="scss" scoped>
* {
  text-decoration: none;
}


.w-100 {
  width: 100%;
}

button {
  &:focus {
    outline: 0 !important;
  }
}

.swiper-container {
  position: relative;

  .header-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding: 25px 42px;

    .header-left {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .box-icon {
        width: 140px;
        height: 48px;
        margin-left: 10px;
        text-align: center;
        border-radius: 24px;
        background-color: #74b73b;
        align-items: center;
        display: flex;
        justify-content: center;

        &-search {
          display: inline-block;
          width: 40px;
          height: 40px;
          padding: 6px;
          cursor: pointer;

          svg {
            width: 24px;
            height: 24px;
          }

          &:focus {
            outline: 0;
          }
        }

        &-user {
          display: inline-block;
          width: 40px;
          height: 40px;
          padding: 6px;
          cursor: pointer;

          svg {
            width: 24px;
            height: 24px;
          }
        }

        &-lang {
          width: 40px;
          height: 40px;
          padding: 6px;
          cursor: pointer;
          color: #fff;

          span {
            width: 24px;
            height: 24px;
            display: inline-block;
            font-weight: bold;
          }

          &:focus {
            outline: 0;
          }
        }
      }

      .hamburglar {
        width: 40px;
        height: 40px;
        padding: 6px;
        cursor: pointer;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    .close {
      position: relative;
      border: 0;
      cursor: pointer;
      width: 47px;
      height: 47px;
      line-height: 47px;
      border-radius: 50%;
      background-color: #f9f9f9;
      color: #161616;

      &:focus {
        outline: 0;
      }

      svg {
        width: 21px;
        height: 21px;
        position: absolute;
        top: 18px;
        right: 0;
        left: 8px;
        margin: auto;
        display: flex;

        &:hover {

        }
      }
    }

    .right-drawer {
      position: absolute;
      top: 0;
      right: 0;
      width: 0; /* initially */
      height: 100vh;
      padding-left: 0; /* initially */
      border-left: 1px solid whitesmoke;
      background: white;
      z-index: 200;
      transition: all 0.5s;
      overflow: scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &-active {
        width: 25vw !important;
        opacity: 1 !important;
        padding-left: 10px !important;
      }

      .nav-header {
        padding: 55px 35px 40px;

        .drop {
          padding: .3em 0;
          font-weight: bold;
          color: #161616;
          transition: all 0.3s ease;

          span {
            padding: 12px 0;
            font-size: 14px;

          }

          svg {
            path {
              transition: all 0.3s ease;
            }
          }

          &:hover {
            color: #74b73b;
            transition: all 0.3s ease;

            span {
              color: #74b73b;
              transition: all 0.3s ease;
            }

            svg {
              path {
                stroke: #74b73b !important;
                transition: all 0.3s ease;
              }
            }
          }
        }

        .dropped-box {
          display: flex;
          flex-direction: column;
          padding-right: 10px;
          transition: all 0.5s ease;

          &-tow {
            display: flex;
            flex-direction: column;
            padding-right: 20px;
          }

          &-item {
            color: #161616;
            transition: all 0.3s ease;

            &:hover {
              color: #74b73b;
              transition: all 0.3s ease;
            }
          }
        }
      }
    }

    .drawer-mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 0; /* initially */
      height: 100vh;
      background: #000;
      opacity: 0.3;
      z-index: 199;
      transition: opacity 0.5s;

      &-active {
        width: 100vw !important;
        opacity: 0.6 !important;
      }
    }
  }


  /*swiper*/
  .swiper-content {
    .swiper-slide {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      background-color: transparent;

      .swiper-box {
        position: relative;
        height: 100vh;

        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          right: 0;
          left: 0;
          top: 0;
        }

        .swiper-img {
          width: 100%;
          height: 100%;
        }

        &-text {
          width: 400px;
          position: absolute;
          bottom: 90px;
          left: 70px;
          z-index: 1;

          .swiper-title {
            font-size: 28px;
            color: #74b73b;
          }

          .swiper-des {
            font-size: 32px;
            color: #fff;
          }
        }
      }
    }
  }
}

@media (max-width: 375px) {
  .swiper-container {
    .header-top {
      flex-direction: column;
      align-items: center;

      .right-drawer {
        &-active {
          width: 100vw !important;
        }
      }
    }

    .swiper-content {
      .swiper-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        background-color: transparent;

        .swiper-box {
          &-text {
            width: 270px;
            left: 0;
            margin: auto;
            right: 0;


            .swiper-title {
              font-size: 28px;
              color: #74b73b;
            }

            .swiper-des {
              font-size: 32px;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 375px) and (max-width: 767px) {
  .swiper-container {
    .header-top {
      .right-drawer {
        &-active {
          width: 54vw !important;
        }
      }
    }

    .swiper-content {
      .swiper-slide {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        background-color: transparent;

        .swiper-box {
          &-text {
            width: 300px;
            left: 0;
            margin: auto;
            right: 0;


            .swiper-title {
              font-size: 28px;
              color: #74b73b;
            }

            .swiper-des {
              font-size: 32px;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .swiper-container {
    .header-top {
      .right-drawer {
        &-active {
          width: 32vw !important;
        }
      }
    }
  }
}

@media (min-width: 992px) {

}

@media (min-width: 1200px) {

}

.hover {
  color: #FFFFFF !important;
}


.header-color {
  background: white;
  transition: background-color 300ms ease-in;
  color: black;
}
</style>
